/**
 * TycoonEX Home — AI assistant roster.
 * agentId 는 백엔드 AGENT_CARD_AGENT_IDS(agent_cards.rs)와 반드시 동일해야 한다.
 */
export type HomeAgent = {
  agentId: string;
  name: string;
  portrait: string;
};

export const HOME_AGENTS: HomeAgent[] = [
  { agentId: "openai-gpt", name: "Emma", portrait: "/images/agents/emma.webp" },
  { agentId: "grok-x", name: "Ellie", portrait: "/images/agents/ellie.webp" },
  { agentId: "qwen-3-6-plus", name: "Clara", portrait: "/images/agents/clara.webp" },
  { agentId: "gemini-pro", name: "Lisa", portrait: "/images/agents/lisa.webp" },
  { agentId: "deepseek-chat", name: "Sophie", portrait: "/images/agents/sophie.webp" },
  { agentId: "claude-opus", name: "Olivia", portrait: "/images/agents/olivia.webp" },
];
